import { Component, OnInit, ViewChild } from '@angular/core';
import { PumpService } from '../../services/pump.service';
import { MatPaginator, MatSort, MatTableDataSource, MatDialog, MatDialogConfig } from '@angular/material'
import { CustomDateComponent } from '../../reports/customdate/custom-date.component';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
@Component({
  selector: 'app-pumpalertreport',
  templateUrl: './pumpalertreport.component.html',
  styleUrls: ['./pumpalertreport.component.scss']
})
export class PumpalertreportComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  pumpIdsArray;
  timeOptions: any = ['Today', 'Yesterday', 'This Week', 'This Month', 'Last Month', 'Custom'];
  columns =[];
  timeFilter;
  dataSource;
  reportColumns;
  parametervalue;
  idFilter; 
  currentUserData = JSON.parse(localStorage.getItem('userData'));
  reportData;
  data;
  customeSelectedDate: any;
  constructor(private pumpservice:PumpService,private matDialog: MatDialog) { }

  ngOnInit() {
    this.timeFilter ={
      type: "Today",
      startDate: "",
      endDate: ""
  };;
    this.getpumpIds()
  }

  getpumpIds(){
    let data = {"roleid": this.currentUserData.roleid, "userid": this.currentUserData.userid};
    this.pumpservice.getPumpIds(data).subscribe(async (response1: any) => {
      console.log("ksajdhgsatdashbksankdasdvasuhjdinasuhda",response1.result)
      if(response1.result.length>0){
         this.pumpIdsArray = response1.result.map(pump => pump.pump_id);
         this.idFilter = this.pumpIdsArray[0];
         this.filters("pumpid",this.idFilter);
      }
    });
  }
  filters(type: string, value: any) {
    if (type === "pumpid") {         
        this.idFilter = value;
    } else {
      console.log("lakskdsa",value)
        if (value === "Custom") {
            console.log('Custom filter:', value);
            const dialogConfig = new MatDialogConfig();
            let dialogRef = this.matDialog.open(CustomDateComponent, {
                autoFocus: false,
                height: '350px',
                width: '450px',
                data: {
                    "details": "",
                    "action": "Add",
                    selectedDate: this.customeSelectedDate
                }
            });

            dialogRef.afterClosed().subscribe(selectedValue => {
                if (selectedValue) {
                    this.customeSelectedDate = selectedValue;
                    this.timeFilter = {
                        type: value,
                        startDate: selectedValue.startDate,
                        endDate: selectedValue.endDate
                    };
                    
                }
            });
        } else {
          this.timeFilter = {
            type: value,
            startDate: "",
            endDate: ""
        };
        }
    }
    let data = { "pumpid": this.idFilter, "duration": this.timeFilter };
    this.pumpservice.alertReport(data).subscribe(async (response: any) => {
        if(response.result.length > 0){
          console.log("response.result",response.result)
          let data = [];
          response.result.forEach(element =>{data.push(element)});
          this.reportColumns = this.columns.concat(Object.keys(data[0]))
          this.dataSource = new MatTableDataSource(data);
          this.data=data;
          console.log(" let data = [];",this.data)
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
    });
}
formatData(data) {
  return new Promise((resolve,reject) => {
      var dataArr = [];
      dataArr.push(this.reportColumns);
      data.forEach(element => {
              dataArr.push(Object.values(element));
      });

      resolve(dataArr);
  })
}
async exportToPdfs() {

        
  this.reportData = await this.formatData(this.data);
  console.log('Formatted Data:', this.reportData);
  var docDefinition = {
      info: {
          title: 'Transformer Report',
        },
      pageOrientation: 'portait',
      pageSize: 'A0',
      content: [
        {
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            headerRows: 1,
           
            widths: [ '10%', '10%', '10%', '10%', '10%'],
          //   body: [
          //      "serialnumber", "DATE", "Winding_Temperature", "Ambient_Temperature", "Humidity", "Oil_Temperature", "Oil_Level", "R_Ph_N", "Y_Ph_N", "B_Ph_N", "Average_Voltage", "RY_Voltage", "YB_Voltage", "BR_Voltage", "L1", "L2", "L3", "LN", "I1", "I2", "I3", "R1", "R2", "R3", "R_Power_Factor", "Y_Power_Factor", "B_Power_Factor", "Avg_Power_Factor", "R_Active_Power", "Y_Active_Power", "B_Active_Power", "3_Phase_Active_Power", "R_Reactive_Power", "Y_Reactive_Power", "B_Reactive_Power", "3_Phase_Reactive_Power", "R_apparent_Power", "Y_apparent_Power", "B_apparent_Power", "3_Phase_Apparent_Power", "Fequency", "Energy_Meter_Temprature", "VR_THD", "VY_THD", "VB_THD", "IR_THD", "IY_THD", "IB_THD", "RP_THD", "YP_THD", "BP_THD", "System_kwh", "System_kvArh", "Deviceid", "Parameter1", "Parameter2", "Parameter3", "Parameter4", "Parameter5", "Parameter6", "Parameter7", "Parameter8", "Parameter9", "Parameter10" ],
          //     [ "serialnumber", "DATE", "Winding_Temperature", "Ambient_Temperature", "Humidity", "Oil_Temperature", "Oil_Level", "R_Ph_N", "Y_Ph_N", "B_Ph_N", "Average_Voltage", "RY_Voltage", "YB_Voltage", "BR_Voltage", "L1", "L2", "L3", "LN", "I1", "I2", "I3", "R1", "R2", "R3", "R_Power_Factor", "Y_Power_Factor", "B_Power_Factor", "Avg_Power_Factor", "R_Active_Power", "Y_Active_Power", "B_Active_Power", "3_Phase_Active_Power", "R_Reactive_Power", "Y_Reactive_Power", "B_Reactive_Power", "3_Phase_Reactive_Power", "R_apparent_Power", "Y_apparent_Power", "B_apparent_Power", "3_Phase_Apparent_Power", "Fequency", "Energy_Meter_Temprature", "VR_THD", "VY_THD", "VB_THD", "IR_THD", "IY_THD", "IB_THD", "RP_THD", "YP_THD", "BP_THD", "System_kwh", "System_kvArh", "Deviceid", "Parameter1", "Parameter2", "Parameter3", "Parameter4", "Parameter5", "Parameter6", "Parameter7", "Parameter8", "Parameter9", "Parameter10" ],
          //    // [ { text: 'Bold value', bold: true }, 'Val 2', 'Val 3', 'Val 4' ]
          //   ]
          body: this.reportData,
          }
        }
      ]
    };
  
     // const documentDefinition = { content: 'This is for testing.' };
      pdfMake.createPdf(docDefinition).download();


}
refreshData() {
  this.ngOnInit();
}

}
